import QRCode from "react-qr-code";
import ConfirmationPhone from "@/assets/images/booking/confirmation-phone.svg";
import DownloadAppStore from "@/assets/images/download-appstore.png";
import DownloadGooglePlay from "@/assets/images/download-googleplay.png";
import { Typography } from "@/components/atoms";
import { useSiteConfig } from "@/hooks";

// Fallback if the operator hasn't configured a client app link.
const FALLBACK_APP_LINK = "https://rideminder.com";

/** "Download the app" promo band shown beneath the confirmation card. */
export const MobileAppPromo = () => {
  // The client_registration dynamic link routes to web/iOS/Android, so it works for both badges and the QR.
  const { registerLinks } = useSiteConfig();
  const appLink = registerLinks?.client || FALLBACK_APP_LINK;

  return (
    <div className="flex flex-col items-center lg:flex-row lg:items-start lg:justify-center">
      {/* Phone illustration — desktop only. Centered against the right column; height is the knob to tune its size.
          lg:mr-* pushes the phone away from the text (own the gap on the image side). */}
      <img src={ConfirmationPhone} alt="Customer mobile app" className="hidden h-[640px] w-auto shrink-0 lg:-mt-10 lg:mr-6 lg:block" />

      {/* The phone SVG is a 600x600 raster on a white bg with the phone centered (~150px white padding each side).
          Negative margin pulls the text back over that white padding (seamless on the white promo band). Tune to taste. */}
      <div className="w-full lg:max-w-[520px] lg:-ml-40">
        <Typography variant="h2">Customer Mobile App</Typography>
        <Typography variant="paragraph" className="mt-2 text-neutral-dark-gray">
          Download the Customer App to manage and create bookings with ease. Get started by clicking below to download the app.
        </Typography>

        {/* Store badges — 16px below the paragraph, 16px apart */}
        <div className="mt-4 flex flex-wrap gap-4">
          <a href={appLink} target="_blank" rel="noopener noreferrer">
            <img src={DownloadAppStore} className="w-[120px]" alt="Download on the App Store" />
          </a>
          <a href={appLink} target="_blank" rel="noopener noreferrer">
            <img src={DownloadGooglePlay} className="w-[135px]" alt="Get it on Google Play" />
          </a>
        </div>

        {/* TODO: "Refer a friend or executive" panel hidden until the referral feature is ready. */}

        {/* QR — label 24px below the badges, code 20px below the label. Centered on tablet/mobile. */}
        <Typography variant="paragraph" className="mt-6 block text-center text-neutral-dark-gray lg:text-left">
          or Scan the QR to download
        </Typography>
        <div className="mt-5 flex justify-center lg:justify-start">
          <QRCode size={120} value={appLink} />
        </div>
      </div>
    </div>
  );
};
